import React from 'react';
import { useTranslation } from 'react-i18next';
import { navigateToShopifyStatus } from '../../../redux/actions/orders';
import { formatPurchaseDate } from '../../utils/formatPurchaseDate';
import { formatPrice } from '../../utils/formatPrice';

export default function OrderCardOnline({ data, dispatch }) {
  const { t, i18n } = useTranslation();
  const first = data.product_list && data.product_list[0];
  const thumb = first && first.picture_url;
  const itemCount = data.product_list
    ? data.product_list.reduce((s, p) => s + (Number(p.product_qty) || 0), 0)
    : 0;
  const clickable = data.is_shopify === 1 && data.order_id_origin;

  const handleActivate = () => {
    if (clickable) {
      dispatch(navigateToShopifyStatus(data.order_id_origin));
    }
  };

  const handleKeyDown = (e) => {
    if (!clickable) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleActivate();
    }
  };

  return (
    <div
      className={`orders-order-card${clickable ? ' orders-order-card--clickable' : ''}`}
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
      onClick={clickable ? handleActivate : undefined}
      onKeyDown={clickable ? handleKeyDown : undefined}
    >
      <div className="orders-order-card__thumb-wrap">
        <div className="orders-order-card__thumb-inner">
          {thumb ? <img src={thumb} alt="" /> : null}
        </div>
      </div>
      <div className="orders-order-card__main">
        <div className="orders-order-card__main-col">
          <div className="orders-order-card__id" title={data.order_id}>{data.order_id}</div>
          <div className="orders-order-card__muted">
            {t('ordersLayout.itemsCount', { count: itemCount })}
          </div>
        </div>
        <div className="orders-order-card__col">
          <div className="orders-order-card__status">{t('ordersLayout.dateLabel')}</div>
          <div className="orders-order-card__muted">
            {formatPurchaseDate(data.purchase_date, i18n.language)}
          </div>
        </div>
        <div className="orders-order-card__price">
          {formatPrice(data.order_grand_total, data.product_price_currency, i18n.language)}
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/js/components/ordersLayout/OrderCardOnline.jsx